export default __webpack_public_path__ + "static/media/cain7.6f5638b1.jpg";